import React, {Component} from 'react';
import {Form, FormGroup, ControlLabel} from "react-bootstrap";
import ReactNotify from 'react-notify';
import moment from 'moment'
import DateFormat from "../../../../utilities/DateAndTimeFormat";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";

export default class UrzadRaportPoLiniachSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: null,
            koniec: null,
            validatorMessages: [],
        };
        this.onChangeStart = this.onChangeStart.bind(this)
        this.onChangeKoniec = this.onChangeKoniec.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentWillReceiveProps(nextprops) {

    }

    componentDidMount() {

        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')
        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            start: moment(pierwszy_miesiaca),
            koniec: moment(ostatni_miesiaca)
        })

    }

    onChangeStart(e) {
        this.setState({start: e})
    }

    onChangeKoniec(e) {
        this.setState({koniec: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickSzukaj() {
        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.start)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty startowej')
        }

        if (!Boolean(this.state.koniec)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty końcowej')
        }

        if (this.state.koniec < this.state.start) {
            poprawne = false;
            this.dodajDoValidatorMessages('Data startowa nie może być późniejsza niż data końcowa')
        }

        if (poprawne) {
            this.setState({validatorMessages: []})
            this.props.handleClickSzukaj(DateFormat.formatYYYYMMDD(this.state.start), DateFormat.formatYYYYMMDD(this.state.koniec))
        }
    }


    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>

                <Form inline={true}>
                    <div>
                        <ControlLabel>
                            Zakres dat od - do
                        </ControlLabel>
                    </div>
                    <FormGroup>
                        <TopInputDate onChange={this.onChangeStart} value={this.state.start}/>
                        <div className={'add-space'}></div>
                        <TopInputDate onChange={this.onChangeKoniec} value={this.state.koniec}/>
                        <div className={'add-space'}></div>
                        <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnSize={'medium'} onClick={this.onClickSzukaj}/>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validatorMessages}/>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_sprzedazy_po_liniach/components/UrzadRaportPoLiniachSearchbox.js